<template>
    <div id="inner">
        <div id="top-anchor"></div>
        <b-row>
            <b-col>
                <p>
                    Hier vindt u uw reactie(s) op geadverteerde woningen waarvan de toewijzing nu nog afgewerkt wordt.
                </p>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <div v-if="!finished" class="text-center">
                    <br/>
                    <h1>Bezig met laden...</h1>
                </div>
                <div v-else-if="adverts.length === 0" class="text-center">
                    <br/>
                    <h1>Geen reacties op advertenties die nog in behandeling zijn</h1>
                </div>
                <div v-else class="archive" v-for="advert in adverts" :key="advert.advert">
                    <hr/>
                    <house-blurb
                            :advert="advert"
                            :showLetters="true"
                            :withdrawType="'withdrawReaction'"
                            :showRemainingTime="false"
                            @withdraw="openReactionWithdraw"
                    >
                    </house-blurb>
                </div>
            </b-col>
        </b-row>
        <b-modal
                id="withdraw-reaction-modal"
                title="Wilt u uw reactie verwijderen?"
                size="lg"
                ok-title="Mijn reactie verwijderen"
                ok-variant="danger"
                @ok="confirmReactionWithdraw"
                cancel-title="Annuleren"
                cancel-variant="info"
        >
            <b-row v-if="Object.keys(withdrawAdvert).length > 0" class="archive-block-details">
                <b-col cols="12">
                    <h1 v-if="withdrawAdvert.type === 'project'">
                        {{withdrawAdvert.title}}
                    </h1>
                    <h1 v-else>
                        {{withdrawAdvert.address.street}} {{withdrawAdvert.address.number}}
                    </h1>
                    <h2>
                        {{withdrawAdvert.address.city}}
                    </h2>
                </b-col>
                <b-col cols="12">
                    <b-row>
                        <b-col cols="6">
                            <i class="fad fax fa-pencil"></i>
                            <strong>
                                Gereageerd op
                            </strong>
                        </b-col>
                        <b-col cols="6">
                            {{withdrawAdvert.regDate}}
                        </b-col>
                    </b-row>
                    <br/>
                    <b-row>
                        <b-col cols="6">
                            <i class="fad fax fa-ticket"></i>
                            <strong>
                                Uw positie
                            </strong>
                        </b-col>
                        <b-col cols="5">
                            <i class="fad fax fa-thermometer"></i>
                            &nbsp;&nbsp;&nbsp;
                            {{withdrawAdvert.position}}
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <br/>
            <b-row>
                <b-col class="text-muted">
                    Weet u zeker dat u uw reactie wilt verwijderen? Indien u deze reactie verwijderd komt u niet meer in aanmerking voor deze woning.
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
    import {reactionService} from "../../_services/reaction.service";
    import houseBlurb from '@/components/_reaction/houseBlurb'

    export default {
        components: { houseBlurb },
        props: [
            'adverts',
            'finished'
        ],
        data: () => {
            return {
                withdrawAdvert: {}
            }
        },
        name: 'inOffer',
        mounted() {

        },
        methods: {
            openReactionWithdraw(advert) {
                this.withdrawAdvert = advert
                this.$bvModal.show('withdraw-reaction-modal')
                let anchor = this.$el.querySelector('#top-anchor')
                anchor.scrollIntoView({ behavior: 'smooth' })
            },
            confirmReactionWithdraw(e) {
                e.preventDefault()
                reactionService.withdrawReaction(this.withdrawAdvert.advert).then((data) => {
                    this.$emit('reload')
                    this.$bvModal.hide('withdraw-reaction-modal')

                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .item-icon {
        width: 100px;
    }
</style>
